/** 封面按贴纸 id 指向，拖动只改数组顺序。云上的文件名和版本号不动。 */

function moveAt(list, from, to) {
  const next = Array.isArray(list) ? list.slice() : []
  if (from < 0 || from >= next.length || to < 0 || to >= next.length) {
    return next
  }
  const [item] = next.splice(from, 1)
  next.splice(to, 0, item)
  return next
}

export function reorderStickers(exta, from, to) {
  if (!exta || !Array.isArray(exta.stickers) || from === to) {
    return exta
  }
  if (from < 0 || to < 0 || from >= exta.stickers.length || to >= exta.stickers.length) {
    return exta
  }
  exta.stickers = moveAt(exta.stickers, from, to)
  return exta
}

/** 有身份且有文件的贴纸就能当托盘；合格只是给 App 的提示。 */
export function usableAsTray(sticker) {
  return !!sticker && !!sticker.file && !!sticker.id
}

export function chooseTray(exta, index) {
  if (!exta || !Array.isArray(exta.stickers) || !Number.isInteger(index) || index < 0) {
    return false
  }
  const sticker = exta.stickers[index]
  if (!usableAsTray(sticker)) {
    return false
  }
  exta.trayStickerId = sticker.id
  return true
}

/** 默认托盘：第一张合格的，全部不合格取第一张；与后端 StickerZipApplier.defaultTray 同一规则。 */
export function defaultTrayId(stickers) {
  const usable = (Array.isArray(stickers) ? stickers : []).filter(usableAsTray)
  const preferred = usable.find((item) => item.qualified === true) || usable[0]
  return preferred ? preferred.id : null
}
